import React from 'react';

import EmailIcon from '@mui/icons-material/Email';
import GppBadIcon from '@mui/icons-material/GppBad';
import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 64px)',
    backgroundColor: '#f5f5f5',
  },
  card: {
    maxWidth: 500,
    textAlign: 'center',
  },
  icon: {
    fontSize: 60,
    color: '#ff9800',
  },
}));

export const AccessRestricted = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Stack sx={{ textAlign: 'center', marginBottom: 2 }}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='center'
          marginBottom={2}
        >
          <GppBadIcon className={classes.icon} />
        </Stack>
        <Typography variant='h4' component='h1' fontWeight='bold' gutterBottom>
          Access Restricted
        </Typography>
        <Typography variant='body1' color='textSecondary' paragraph>
          You don't have permission to access this page
        </Typography>
      </Stack>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant='h6' component='h2' gutterBottom>
            Permission Required
          </Typography>
          <Typography variant='body2' color='textSecondary' paragraph>
            This page requires additional permissions that haven't been granted
            to your account.
          </Typography>
          <Typography variant='subtitle1' gutterBottom>
            What you can do:
          </Typography>
          <Button
            variant='outlined'
            startIcon={<EmailIcon />}
            href={`${process.env.REACT_APP_FORMS_BASE_URL}?id=${process.env.REACT_APP_SELF_REGISTER_FORM_ID}`}
          >
            Request Access
          </Button>
        </CardContent>
      </Card>
      <Stack sx={{ textAlign: 'center' }}>
        <Typography
          variant='caption'
          color='textSecondary'
          display='block'
          sx={{ marginTop: 2 }}
        >
          If you believe this is an error, please contact your administrator
        </Typography>
        <Typography variant='caption' color='textSecondary' display='block'>
          Error Code: 403 - Forbidden
        </Typography>
      </Stack>
    </div>
  );
};
